module.exports = __webpack_public_path__ + "static/media/logo-natioanls.c8b28244.png";